import Controller from '@ember/controller';
import { action, set } from '@ember/object';
import { inject as service } from '@ember/service';
import { ApplicationFlowUpdate } from '@square/dashboard-protos/models/squareup/sfs/external/models/application_flow_update';
import { tracked } from '@glimmer/tracking';
import { initializeAction } from '@banking/ui/workflows/onboarding-kyb/action';

export default class ConfirmBusinessController extends Controller {
  @service currentApplicationFlow;
  @service addressValidation;
  @service kybWorkflow;
  @service router;
  @tracked isLoading = false;

  @action
  async continue() {
    try {
      this.isLoading = true;

      let hasSignificantChanges = false;

      if (!this.addressValidation.didShowBusinessValidation) {
        await this.addressValidation.validateAndStandardizeBusiness(
          this.currentApplicationFlow.business.address
        );

        if (!this.addressValidation.businessFailedValidation) {
          hasSignificantChanges = this.addressValidation.hasSignificantChanges(
            this.addressValidation.businessStandardizationChanges
          );

          await this.updateAddress();
        }
      }

      if (
        this.addressValidation.businessFailedValidation &&
        !this.addressValidation.didShowBusinessValidation
      ) {
        set(this, 'addressValidation.didShowBusinessValidation', true);
        this.router.transitionTo('signup.confirm-business.invalid-address');
      } else if (hasSignificantChanges) {
        set(this, 'addressValidation.didShowBusinessValidation', true);
        this.router.transitionTo('signup.confirm-business.address');
      } else {
        this.initKyb();
      }
    } catch (error) {
      this.send('handleRpcError', error);
    } finally {
      this.isLoading = false;
    }
  }

  initKyb() {
    const initialize = initializeAction({
      businessName: this.currentApplicationFlow.business?.businessName,
      entityType: this.currentApplicationFlow.business?.businessType,
      taxIdSerialNumber: this.currentApplicationFlow.business?.businessEinLast4,
      existingIndividuals: this.currentApplicationFlow.controllingIndividuals,
    });

    this.kybWorkflow.emit(initialize);
  }

  async updateAddress() {
    const businessUpdate = new ApplicationFlowUpdate.BusinessUpdate.Builder()
      .address(this.addressValidation.businessStandardizedAddress)
      .build();

    const applicationFlowUpdate = new ApplicationFlowUpdate.Builder()
      .id(this.currentApplicationFlow.id)
      .business(businessUpdate)
      .build();

    await this.currentApplicationFlow.update(applicationFlowUpdate);
  }
}
